/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard components

// Dashboard example components

// @mui material components

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";

// import AcceptedRejectionsW2 from "./REJSTW2/rejection-2";
// import AcceptedRejectionsW3 from "./REJSTW3/rejection-2";
// import REJSTW from "./REJSTW";
import CATATW from "./CATATW/index";
import CATATW1 from "./CATATW1/index";

const cookies = new Cookies();

const CategoryCreationParent = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let showCATATW1 = modulesData.find(
    (moduleId) => moduleId.moduleId == "aba67f3b-835e-432a-b321-15dccd64a005",
  );

  // let showCATATW1 =true

  let showCATATW = modulesData.find(
    (moduleId) => moduleId.moduleId == "dc22fa7d-3455-4fdc-bb4d-0d0afeab53ec",
  );

  // let showCATATW =true

  return (
    <>
      {showCATATW1 ? (
        <CATATW1 />
      ) : showCATATW ? (
        <CATATW />
      ) : (
        <>
          <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
            No Category Master Access
          </h4>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapStateToDispatch,
)(CategoryCreationParent);
